// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1bZtw","label":"Labeled_label__NVRkI","divider":"Labeled_divider__1Q3P-"};